import Cookies from 'js-cookie'

const setCookie = function (name = '', value = '') {
  const domain = location.hostname === 'localhost' ? '' : location.hostname
  Cookies.set(`bvi_${name}`, value, { expires: 1, path: '/', domain })
}

const getCookie = function (name = '') {
  return Cookies.get(`bvi_${name}`)
}

const removeCookie = function (name = '') {
  const domain = location.hostname === 'localhost' ? '' : location.hostname
  Cookies.remove(`bvi_${name}`, { path: '/', domain })
}

export { getCookie, removeCookie, setCookie }
